import React from "react";
import styled from "styled-components";
import { MatchSummary } from "../../components";

const PlayoffMatches = ({ matches }) => {
  // Definimos los órdenes personalizados
  const divisionOrder = [
    "Paladines",
    "Campeones",
    "Mandobles",
    "Espadas Largas",
    "Hombre de Armas",
    "Alabarderos",
    "Milicias",
    "Piqueros",
    "Lanceros",
  ];
  const phaseOrder = ["PLAYIN", "PLAYOFF"];
  const playoffTypeOrder = ["Campeón división", "Ascenso", "Descenso"];

  // Función para ordenar por los criterios establecidos
  const sortedMatches = matches.sort((a, b) => {
    return (
      divisionOrder.indexOf(a.divisionName) -
        divisionOrder.indexOf(b.divisionName) ||
      phaseOrder.indexOf(a.phase) - phaseOrder.indexOf(b.phase) ||
      playoffTypeOrder.indexOf(a.playoffType) -
        playoffTypeOrder.indexOf(b.playoffType)
    );
  });

  // Función para agrupar los matches
  const groupedMatches = sortedMatches.reduce((acc, match) => {
    const key = `${match.divisionName}-${match.phase}-${match.playoffType}`;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(match);
    return acc;
  }, {});

  return (
    <Wrapper>
      {/* {matches.map((match) => (
        <MatchSummary
          key={`matchsummary-${match.matchId}`}
          {...match}
          playoff={true}
        />
      ))} */}
      <div>
        {Object.keys(groupedMatches).map((group) => {
          const [divisionName, phase, playoffType] = group.split("-");
          return (
            <div key={group}>
              <h2>{divisionName}</h2>
              <h3>
                {phase} - {playoffType}
              </h3>

              <div className="matches-list">
                {groupedMatches[group].map((match) => (
                  <MatchSummary
                    key={`matchsummary-${match.matchId}`}
                    {...match}
                    playoff={true}
                  />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </Wrapper>
  );
};
const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;

  .matches-list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 2rem;
  }

  h2,
  h3,
  h4 {
    font-size: medium;
  }
`;

export default PlayoffMatches;
